//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { FeatureNames } from '@bvengineering/curalate-features';

import { ICuralateStore } from '@models/AppState';
import { createHasFeatureSelector } from '@redux/selectors/createHasFeatureSelector';

// TODO: PD-249308 - remove rights_requests_include_username flag
export const getIsIncludeUsernameEnabled = (state: ICuralateStore) => {
  return createHasFeatureSelector(FeatureNames.RightsRequestsIncludeUsername)(
    state,
  );
};
